// extracted by mini-css-extract-plugin
export default {"editItemContainer":"styles_editItemContainer__V5RFy","readOnly":"styles_readOnly__vsirr","separator":"styles_separator__zJjXY"};